import React, { useRef } from "react";
import { Editor } from "@tinymce/tinymce-react";
import { s3baseUri } from "../../config/config";
import { invokeApi } from "../../utils/invokeApi/invokeApi";
import { useIds } from "../../hook/AdminContext";

export default function GeneralCkeditor({
  inputs,
  setInputs,
  name,
  editorHeight,
  is_array,
  index,
  value,
  customHandleChange = null,
}) {
  const { adminSetting } = useIds();
  const editorKey = adminSetting?.client_editor_key;
  const editorRef = useRef(null);

  const log = () => {
    if (editorRef.current) {
      if (is_array) {
        const list = [...inputs];
        list[index][name] = editorRef.current.getContent();
        setInputs(list);
      } else if (customHandleChange) {
        customHandleChange({
          target: {
            value: editorRef.current.getContent(),
            name: name,
          },
        });
      } else if (inputs) {
        setInputs((prevState) => ({
          ...prevState,
          [name]: editorRef.current.getContent(),
        }));
      } else {
        setInputs(editorRef.current.getContent());
      }
    }
  };

  const handleChange = (value) => {
    if (is_array) {
      const list = [...inputs];
      list[index][name] = value;
      setInputs(list);
    } else if (inputs) {
      setInputs((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    } else {
      setInputs(value);
    }
  };

  async function example_image_upload_handler(blobInfo, progress) {
    const formData = new FormData();
    formData.append("image", blobInfo.blob(), blobInfo.filename());

    const resp = await invokeApi({
      path: "api/app_api/upload_image_s3",
      method: "POST",
      headers: { "x-sh-auth": localStorage.getItem("token") },
      postData: formData,
    });

    if (resp.code === 200 && resp.image_path) {
      return `${s3baseUri}${resp.image_path}`; // ✅ return a plain string URL
    } else {
      throw new Error(resp.message || "Upload failed");
    }
  }

  const editor_value = () => {
    let value_data = "";
    if (is_array && inputs[index][name]) {
      value_data = inputs[index][name];
    } else if (inputs[name]) {
      value_data = inputs[name];
    } else if (value) {
      value_data = value;
    }
    return value_data;
  };

  return (
    <>
      {editorKey && (
        <Editor
          onChange={log}
          value={editor_value()}
          onInit={(evt, editor) => (editorRef.current = editor)}
          onEditorChange={(newValue, editor) => {
            log(newValue, editor);
          }}
          apiKey={editorKey}
          init={{
            images_upload_handler: example_image_upload_handler,
            height: editorHeight ? editorHeight : 500,
            menubar: false,
            contextmenu:
              "undo redo | cut copy paste | bold italic underline | link image | alignleft aligncenter alignright | removeformat",
            plugins:
              "anchor autolink charmap codesample emoticons link lists searchreplace visualblocks wordcount",
            toolbar:
              "undo redo | bold italic underline strikethrough | link table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat",
          }}
        />
      )}

      {/* <Editor
        apiKey="qmpa4ui0jd31xz7fryfkvp7t79l25ahalsh0e9xieynk2vlv"
        onChange={log}
        value={editor_value()}
        onInit={(evt, editor) => (editorRef.current = editor)}
        onEditorChange={(newValue, editor) => {
          log(newValue, editor);
        }}
        init={{
          menubar: true,
          plugins: [
            "advlist autolink lists link image charmap print preview anchor",
            "searchreplace visualblocks code fullscreen",
            "insertdatetime media table paste code help wordcount",
            "image media", // ✅ Yahan 'image' plugin add kar diya hai
          ],
          toolbar:
            "undo redo | formatselect | " +
            "bold italic backcolor | alignleft aligncenter " +
            "alignright alignjustify | bullist numlist outdent indent | " +
            // "removeformat | help",
            "image media | removeformat | help", // ✅ Yahan 'image' button bhi add kar diya hai

          content_style:
            "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
        }}
      /> */}
    </>
  );
}
